import { useContext } from 'react';
import TraitCollectionContext from '../contexts/TraitCollectionContext';

const useTraitCollectionContext = () => useContext(TraitCollectionContext);

export default useTraitCollectionContext;
